import { ContentPatchBody, MediaResponse } from '../../../../API';

// OpenAPI Generator renames the reserved word `default` to `_default` on the generated models.
// The API still reads and writes the property as `default`, so these types keep the wire shape
// and drop the generated field.
export enum ContentLabelType {
  COMING_SOON = 'COMING_SOON'
}

export interface ContentLabelBody {
  label: ContentLabelType;
  endDate?: string;
  displayText?: string;
}

export interface ContentLabelsBody {
  default?: ContentLabelBody[];
}

export type MediaResponseWithContentLabels = Omit<MediaResponse, 'contentLabels'> & {
  contentLabels?: ContentLabelsBody;
};

export type ContentPatchBodyWithContentLabels = Omit<ContentPatchBody, 'contentLabels'> & {
  // null clears stored labels. An empty default list is rejected by the API.
  contentLabels?: ContentLabelsBody | null;
};
